import Icon from '../components/Icon.vue'

Icon.register({
  'less-than-equal': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M55 214.2c-13.8-4.5-23-16.6-23-30.2v-16c0-13.6 9.2-25.7 23-30.2l301.7-120c18.3-6 38.5 2.5 45.1 19.1l12 29.9c6.6 16.5-2.8 34.8-21.1 40.8l-175.6 68.1 175.4 68c18.4 6 27.9 24.4 21.2 41l-12.1 30.1c-6.7 16.6-27 25.2-45.4 19.2zM424 400c13.3 0 24 10.7 24 24v48c0 13.3-10.8 24-24 24h-400c-13.3 0-24-10.8-24-24v-48c0-13.3 10.8-24 24-24h400z'
      }
    ]
  }
})
